import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { SportsRoutingModule } from './sports-routing.module'
import { SportListComponent } from './sport-list/sport-list.component'
import { EntityHubModule } from '../entity-hub/entity-hub.module'
import { SportsDataService } from './sports-data.service'
import { ContentRightRailLayoutModule } from '../libs/_layouts/content-right-rail-layout/content-right-rail-layout.module'
import { ErrorModule } from '../libs/error/error.module'
import { IfLoadedModule } from '../shared/directives/if-loaded/if-loaded.module'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SportsRoutingModule,
    EntityHubModule,
    ContentRightRailLayoutModule,
    ErrorModule,
    IfLoadedModule
  ],
  declarations: [SportListComponent],
  providers: [SportsDataService]
})
export class SportsModule {}
